import React, { useState, useEffect } from "react";
import "./TagModal.css";

export default function TagModal({
  isOpen,
  onClose,
  onSave,
  initialQuery = "",
}) {
  const [tagName, setTagName] = useState("");
  const [tagLabel, setTagLabel] = useState("");
  const [tagType, setTagType] = useState("Basic"); // "Basic" | "Checkmark"
  const [defaultChecked, setDefaultChecked] = useState(false);
  const [defaultInfo, setDefaultInfo] = useState("");
  const [specificInfo, setSpecificInfo] = useState("");

  useEffect(() => {
    if (isOpen) {
      setTagName(initialQuery || "");
      setTagLabel(initialQuery || "");
      setTagType("Basic");
      setDefaultChecked(false);
      setDefaultInfo("");
      setSpecificInfo("");
    }
  }, [isOpen, initialQuery]);

  if (!isOpen) return null;

  const handleSaveForm = () => {
    const payload = {
      id: null,
      name: tagName.trim(),
      label: tagLabel.trim() || tagName.trim(),
      type: tagType,
      default_active: tagType === "Checkmark" ? defaultChecked : false,
      default_info: defaultInfo.trim(),
      specific_info: specificInfo.trim(),
    };
    onSave(payload);
  };

  return (
    <div className="tag-modal-overlay" onClick={onClose}>
      <div
        className="tag-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="tag-modal-header">
          <h3>Tag hinzufügen</h3>
          <button
            className="tag-modal-close"
            onClick={onClose}
            aria-label="Schließen"
          >
            ✕
          </button>
        </div>

        <div className="tag-modal-body">
          {/* --- Formfelder für neuen Tag --- */}
          <div className="tag-modal-form" id="tag-modal-form">
            <div className="tag-modal-row">
              <label htmlFor="tag-name">Tag Name</label>
              <input
                id="tag-name"
                className="tag-modal-input"
                type="text"
                value={tagName}
                onChange={(e) => setTagName(e.target.value)}
                placeholder="Interner Name"
              />
            </div>

            <div className="tag-modal-row">
              <label htmlFor="tag-label">Tag Label</label>
              <input
                id="tag-label"
                className="tag-modal-input"
                type="text"
                value={tagLabel}
                onChange={(e) => setTagLabel(e.target.value)}
                placeholder="Angezeigter Name"
              />
            </div>

            <div className="tag-modal-row">
              <span className="tag-modal-type-label">Tag-Typ</span>
              <div className="tag-modal-type fullwidth">
                <button
                  type="button"
                  className={`tag-type-option ${
                    tagType === "Basic" ? "selected" : ""
                  }`}
                  onClick={() => setTagType("Basic")}
                >
                  Basic Tag
                </button>
                <button
                  type="button"
                  className={`tag-type-option ${
                    tagType === "Checkmark" ? "selected" : ""
                  }`}
                  onClick={() => setTagType("Checkmark")}
                >
                  Checkmark Tag
                </button>
              </div>
            </div>

            {tagType === "Checkmark" && (
              <div className="tag-modal-row tag-modal-checkmark-extra">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={defaultChecked}
                    onChange={(e) => setDefaultChecked(e.target.checked)}
                  />
                  <span className="slider"></span>
                  <span className="switch-label">Standardmäßig aktiv</span>
                </label>
              </div>
            )}

            <div className="tag-modal-row">
              <label htmlFor="tag-default-info">Default Info</label>
              <textarea
                id="tag-default-info"
                className="tag-modal-textarea"
                value={defaultInfo}
                onChange={(e) => setDefaultInfo(e.target.value)}
                placeholder="Allgemeine Standard-Information"
                rows={3}
              />
            </div>

            <div className="tag-modal-row">
              <label htmlFor="tag-specific-info">Specific Tag Info</label>
              <textarea
                id="tag-specific-info"
                className="tag-modal-textarea"
                value={specificInfo}
                onChange={(e) => setSpecificInfo(e.target.value)}
                placeholder="Spezifische Informationen für dieses Tag"
                rows={3}
              />
            </div>
          </div>

          {/* Footer */}
          <div className="tag-modal-footer">
            <button className="tag-modal-btn ghost" onClick={onClose}>
              Abbrechen
            </button>
            <button
              className="tag-modal-btn primary"
              onClick={handleSaveForm}
              disabled={!tagName.trim() && !tagLabel.trim()}
            >
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
